import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { notificationKeys } from '../notificationQueryKeys'
import type { Notification } from '../../types/notificationTypes'

// Optimistic-only while the backend is mocked. When `/api/notifications/{id}/read`
// ships, set mutationFn to markNotificationRead and add an onError rollback.
export function useMarkNotificationReadMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => Promise.resolve(id),
    onMutate: (id: string) => {
      qc.setQueryData<Notification[]>(notificationKeys.list(), (current) =>
        (current ?? []).map((notification) =>
          notification.id === id ? { ...notification, isRead: true } : notification,
        ),
      )
    },
  })
}
